import decodeId from 'core/libs/helpers/decodeId';
import formattedRelativeTime from 'core/libs/helpers/formattedRelativeTime';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import Tabs from 'modules/common/Tabs';
import PropTypes from 'prop-types';
import React, {lazy, Suspense} from 'react';
import {FormattedMessage} from 'react-intl';
import ProjectFeedback from '../ProjectFeedback';
import ModalProjectHistory from './ModalProjectHistory';
import {circle} from './styles.scss';

const CodeReview = lazy(() => import('../CodeReview'));

const ProjectHistory = ({
  feedback,
  files,
  allProjectSubmission,
  step,
  trackId,
  partner,
}) => {
  const reviewCountArray =
    files &&
    files.length > 0 &&
    files.map(
      (file) => file.reviewSet.edges.length > 0 && file.reviewSet.edges.length,
    );
  const reviewCount =
    reviewCountArray && reviewCountArray.reduce((acc, review) => acc + review);
  return (
    <div className="tr ph6-ns ph2 pv4-ns pv2">
      {allProjectSubmission &&
        allProjectSubmission
          .slice()
          .reverse()
          .map((projectSubmission, index) => {
            const reviewNumber = (
              <h3>
                <FormattedMessage id="review" /> #{index + 1}{' '}
              </h3>
            );
            const currentUrl = window.location.pathname;
            const projectSubmissionId = decodeId(projectSubmission.node.id);
            return (
              <div key={index} className="bb b--light-gray pv4">
                <div className="flex items-center">
                  {index === allProjectSubmission.length - 1 ? (
                    reviewNumber
                  ) : (
                    <ModalProjectHistory
                      submissionPath={`${currentUrl}?submission=${projectSubmissionId}`}
                      projectPath={currentUrl}
                      title={reviewNumber}
                    >
                      <Tabs
                        titles={[
                          <FormattedMessage id="feedback" />,
                          <>
                            {reviewCount > 0 && (
                              <span className={`${circle} ph2 mh2`}>
                                {reviewCount}
                              </span>
                            )}
                            <FormattedMessage id="review" />
                          </>,
                        ]}
                        contents={[
                          <ProjectFeedback
                            feedback={feedback}
                            step={step}
                            isSubmissionHistory
                            trackId={trackId}
                            partner={partner}
                          />,
                          <Suspense fallback={<LoadingIndicator />}>
                            <CodeReview files={files} />
                          </Suspense>,
                        ]}
                        isProjectReview
                        isSubmissionHistory
                      />
                    </ModalProjectHistory>
                  )}
                  {index === allProjectSubmission.length - 1 && (
                    <span className="ph2 f5 fw6">
                      <FormattedMessage id="this_review" />
                    </span>
                  )}
                </div>
                {projectSubmission.node.updatedAt && (
                  <div className="pv2">
                    <span className="silver">
                      <FormattedMessage id="reviewed_at" />{' '}
                      {formattedRelativeTime(projectSubmission.node.updatedAt)}
                    </span>
                  </div>
                )}
                {projectSubmission.node.note && (
                  <div className="pv3">
                    <h4 className="black-80">
                      <FormattedMessage id="student_note" />
                    </h4>
                    <p className="pv2 silver">{projectSubmission.node.note}</p>
                  </div>
                )}
              </div>
            );
          })}
    </div>
  );
};

ProjectHistory.propTypes = {
  feedback: PropTypes.array,
  files: PropTypes.array,
  allProjectSubmission: PropTypes.array.isRequired,
  step: PropTypes.object,
  trackId: PropTypes.string.isRequired,
  partner: PropTypes.string.isRequired,
};

export default ProjectHistory;
